/* IntelliCart theme JS */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Mobile menu
    var menuBtn = document.querySelector('[data-menu-toggle]');
    var mobileNav = document.querySelector('[data-mobile-nav]');
    if (menuBtn && mobileNav) {
      menuBtn.addEventListener('click', function () {
        var open = mobileNav.classList.toggle('is-open');
        menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // Search bar
    var searchBtn = document.querySelector('[data-search-toggle]');
    var searchBar = document.querySelector('[data-search-bar]');
    if (searchBtn && searchBar) {
      searchBtn.addEventListener('click', function () {
        var open = searchBar.classList.toggle('is-open');
        if (open) {
          var input = searchBar.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });
    }

    // Quantity steppers
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var current = parseInt(input.value, 10) || 1;
          var min = parseInt(input.min, 10);
          if (isNaN(min)) min = 0;
          var next = btn.dataset.dir === 'up' ? current + 1 : current - 1;
          input.value = Math.max(min, next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    // Product page: gallery + variants
    var productRoot = document.querySelector('[data-product]');
    if (productRoot) {
      var dataEl = productRoot.querySelector('[data-product-json]');
      var product = dataEl ? JSON.parse(dataEl.textContent) : null;
      var idInput = productRoot.querySelector('[data-variant-id]');
      var priceEl = productRoot.querySelector('[data-price]');
      var addBtn = productRoot.querySelector('[data-add-btn]');
      var stockEl = productRoot.querySelector('[data-stock]');
      var mainImg = productRoot.querySelector('.gallery__main img');
      var selects = productRoot.querySelectorAll('[data-option]');

      var currency = productRoot.dataset.currency || 'USD';
      function money(cents) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(cents / 100);
        } catch (e) {
          return (cents / 100).toFixed(2);
        }
      }

      function currentVariant() {
        if (!product) return null;
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        return product.variants.find(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        });
      }

      function update() {
        var v = currentVariant();
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
          return;
        }
        idInput.value = v.id;
        if (priceEl) {
          priceEl.innerHTML = v.compare_at_price && v.compare_at_price > v.price
            ? '<ins>' + money(v.price) + '</ins> <s>' + money(v.compare_at_price) + '</s>'
            : money(v.price);
          priceEl.classList.toggle('price--sale', !!(v.compare_at_price && v.compare_at_price > v.price));
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
        }
        if (stockEl) {
          stockEl.textContent = v.available ? 'In stock — ready to ship' : 'Currently sold out';
          stockEl.className = 'stock' + (v.available ? '' : ' stock--out');
        }
        if (v.featured_image && mainImg) {
          mainImg.src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_1000x$1$2');
        }
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', update); });

      productRoot.querySelectorAll('[data-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (mainImg) {
            mainImg.src = btn.dataset.src;
            mainImg.alt = btn.dataset.alt || '';
          }
          productRoot.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
    }

    // Auto-submit sort / filter forms
    document.querySelectorAll('[data-autosubmit]').forEach(function (el) {
      el.addEventListener('change', function () {
        var form = el.closest('form');
        if (form) form.submit();
      });
    });
  });
})();
